import {authorizationFieldFormattedValue, AuthorizationInfo} from "./domain";
import {AuthorizationListColumn} from "./ClientProfileAuthorizationPage";
import {ParentCaseAuthorizationListAction} from "./parentCaseAuthorizationReducer";
import React from "react";
import {Paths} from "../../common";
import {get} from "lodash";

type AuthorizationListRowItemProps = {
    authorization: AuthorizationInfo;
    selected: boolean,
    dispatch: React.Dispatch<ParentCaseAuthorizationListAction>
}

export function AuthorizationListRowItem({authorization, selected, dispatch}: AuthorizationListRowItemProps) {
    const escFunction = React.useCallback((event) => {
        if (event.keyCode === 27) {
            dispatch({type: 'HIDE_MODAL'});
            dispatch({type: 'SET_SELECTED', selectedAuthorizationGuid: null});
        }
    }, [dispatch]);

    React.useEffect(() => {
        document.addEventListener("keydown", escFunction, false);

        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [escFunction]);

    const displayCol = (attr: Paths<AuthorizationInfo>) => {
        if (attr === 'allServiceType') {
            return get(authorization, attr).join(', ');
        } else {
            return authorizationFieldFormattedValue(authorization, attr);
        }
    }

    return (
        <tr className={`border-b border-gray-200 hover:${selected ? 'bg-botticelli-100' : 'bg-gray-200'} ${selected ? 'bg-botticelli-100 text-white' : ''}`}
            onClick={() => dispatch({type: 'SET_SELECTED', selectedAuthorizationGuid: authorization.guid})}>
            {
                AuthorizationListColumn.map((column) => (
                    <td
                        key={column.name}
                        className={'py-5' + (column.attr === 'bhpnAuthNumber' ? ' pl-4 text-blue-portal-link underline' : '')}
                        colSpan={column.span}
                    >
                        {
                            column.attr === 'bhpnAuthNumber' ?
                                <div onClick={() => dispatch({
                                    type: 'SET_SELECTED_AND_SHOW_MODAL',
                                    selectedAuthorizationGuid: authorization.guid
                                })} className="cursor-pointer">{get(authorization, column.attr)}</div> :
                                displayCol(column.attr)
                        }
                    </td>
                ))
            }
        </tr>
    )

}